export const actionTypes = {
    fetchExplorerSamples: 'FETCH_EXPLORER_SAMPLES',
    receiveExplorerSamples: 'RECEIVE_EXPLORER_SAMPLES',
    clearExplorerSamples: 'CLEAR_EXPLORER_SAMPLES',
};